import { SuspenseSelect } from '@/components/Suspense';
import { useGetInvoiceReportStatuses } from '@/context/services/reportsType/invoiceReports/Edit.service';
import type { AdminInvoiceReportsSearchFormData } from '@/features/admin_invoice_reports/types';
import {
  FormSelect,
  type LabelProps,
  type SelectProps,
} from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';
import type { Control, FieldPath } from 'react-hook-form';

export type PropsControl = {
  control: Control<AdminInvoiceReportsSearchFormData>;
  name: FieldPath<AdminInvoiceReportsSearchFormData>;
  labelProps?: LabelProps;
};

const _AdminInvoiceStatusesSelect: FC<PropsControl> = memo(
  ({ control, name, labelProps }) => {
    const { data } = useGetInvoiceReportStatuses(false);

    const memoizedStatuses = useMemo(() => {
      return (
        data?.data?.map((status) => ({
          label: status.name ?? '',
          value: status.value ?? '',
        })) ?? []
      );
    }, [data?.data]);

    const selectProps: SelectProps = useMemo(
      () => ({
        options: memoizedStatuses,
        label: labelProps,
        size: 'small',
      }),
      [memoizedStatuses, labelProps]
    );

    return (
      <FormSelect<AdminInvoiceReportsSearchFormData>
        control={control}
        name={name}
        inputId={name}
        testId={name}
        selectProps={selectProps}
      />
    );
  }
);

_AdminInvoiceStatusesSelect.displayName = '_AdminInvoiceStatusesSelect';

export const AdminInvoiceStatusesSelect: FC<PropsControl> = memo((props) => (
  <SuspenseSelect>
    <_AdminInvoiceStatusesSelect {...props} />
  </SuspenseSelect>
));

AdminInvoiceStatusesSelect.displayName = 'AdminInvoiceStatusesSelect';
